<!-- TOP -->
<nav
  class="navbar navbar-expand-lg navbar-light bg-light header py-1 px-2 py-md-1 px-md-2 d-flex flex-row justify-content-between"
>
  <span *ngIf="!logoLeft && !showSidebar"></span>
  <button (click)="sidebarService.toggle()" *ngIf="showSidebar" class="btn">
    <fa-icon [icon]="iconToggleSidebar"></fa-icon>
  </button>
  <a
    *ngIf="!customMainLogo"
    [routerLink]="linkTopLogo"
    class="navbar-brand logo"
    tabindex="-1"
  >
    <div
      class="logo"
      style="background-image: url('assets/logos/sanakey-portal.png')"
    ></div>
  </a>
  <a
    *ngIf="customMainLogo"
    [routerLink]="customMainLogoLink"
    class="navbar-brand logo"
    tabindex="-1"
  >
    <div [ngStyle]="customMainLogoStyle" class="logo"></div>
  </a>
  <div class="d-flex align-items-center gap-2">
    <san-info-box-button *ngIf="showInfoBoxButton" class=""></san-info-box-button>
    <san-notification-bell *ngIf="showAccountBoxButton"></san-notification-bell>
    <san-account-button *ngIf="showAccountBoxButton"></san-account-button>
  </div>
  <img
    *ngIf="customLogo"
    [alt]="customLogoAlt"
    [src]="customLogo"
    class="rightCustomLogo p-1"
  />
</nav>

<!--<router-outlet class="flex-fill bg-light p-5 overflow-x-hidden"></router-outlet>-->
<div class="content-container">
  <san-account-switch-loading></san-account-switch-loading>
  <san-side-bar></san-side-bar>
  <div class="content">
    <!-- Breadcrumbs -->
    <!-- CONTENT -->
    <ng-scrollbar
      [autoWidthDisabled]="true"
      class="router-container"
      track="vertical"
    >
      <router-outlet></router-outlet>
    </ng-scrollbar>
    <!-- BOTTOM -->
    <nav
      class="navbar navbar-expand-lg navbar-light bg-light footer small overflow-x-hidden f-flex flex-row justify-content-between"
    >
      <span class=""
      ><a href="https://www.sanakey-contract.de" target="_blank"
      >Sanakey Contract GmbH</a
      >
        &copy; {{ currentYear }}</span
      >
      <span class="">
        <a
          (click)="this.openDatenschutz()"
          href="javascript:void(0)"
          tabindex="-1"
        >
          Datenschutzbestimmungen
        </a>
        |
        <a (click)="this.openNutzung()" href="javascript:void(0)" tabindex="-1">
          Nutzungsbedingungen
        </a>
        |
        <a
          (click)="this.openImpressum()"
          href="javascript:void(0)"
          tabindex="-1"
        >
          Impressum
        </a>
      </span>
    </nav>
  </div>
</div>

<!-- Modals -->
<!-- Header Definition -->
<ng-template
  #modalHeader
  let-allowClose="allowClose"
  let-modal="modal"
  let-title="title"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button
      (click)="modal.dismiss()"
      *ngIf="allowClose"
      aria-label="schließen"
      class="btn-close"
      type="button"
    ></button>
  </div>
</ng-template>

<!-- Content Definition -->
<ng-template #datenschutz let-modal>
  <ng-container
    *ngTemplateOutlet="
      modalHeader;
      context: {
        modal: modal,
        allowClose: true,
        title: 'Datenschutzbestimmungen',
      }
    "
  ></ng-container>
  <div class="modal-body embedding">
    <iframe
      class="fill"
      src="https://www.sanakey.de/sanakey-portal/datenschutz"
    ></iframe>
  </div>
</ng-template>
<ng-template #nutzungsbedingungen let-modal>
  <ng-container
    *ngTemplateOutlet="
      modalHeader;
      context: { modal: modal, allowClose: true, title: 'Nutzungsbedingungen' }
    "
  ></ng-container>
  <div class="modal-body embedding">
    <iframe
      class="fill"
      src="https://www.sanakey.de/sanakey-portal/nutzungsbedingungen"
    ></iframe>
  </div>
</ng-template>
<ng-template #impressum let-modal>
  <ng-container
    *ngTemplateOutlet="
      modalHeader;
      context: { modal: modal, allowClose: true, title: 'Impressum' }
    "
  ></ng-container>
  <div class="modal-body embedding">
    <iframe
      class="fill"
      src="https://www.sanakey.de/sanakey-portal/impressum"
    ></iframe>
  </div>
</ng-template>
<ng-template #processError let-modal>
  <ng-container
    *ngTemplateOutlet="
      modalHeader;
      context: { modal: modal, allowClose: false, title: 'Prozessfehler' }
    "
  ></ng-container>
  <div class="modal-body">
    <p>
      Ein Fehler ist aufgetreten. Sie können das Portal derzeit nicht nutzen.
      Bitte nehmen Sie Kontakt mit dem Service auf.
    </p>
    <div class="d-flex justify-content-center">
      <san-visitenkarte
        abteilung="Allgemeine / technische Fragen zur Funktion des Sanakey-Portals®"
        class="col-xl-4 col-lg-6"
        email="service@sanakey-portal.de"
        servicezeiten="Montag bis Freitag 11 Uhr bis 13 Uhr"
        telefonnummer="030 3100 78 999 (Servicehotline der Sanakey-Gruppe)"
      ></san-visitenkarte>
    </div>
  </div>
</ng-template>

<san-app-toast aria-atomic="true" aria-live="polite"></san-app-toast>
